module.exports = __webpack_public_path__ + "assets/img/GENERATE_DOCUMENT_PLUGIN.74c877e4.svg";